import {
  Component, ElementRef,
  EventEmitter,
  Input,
  OnChanges, OnInit,
  Output, Renderer2,
  SimpleChanges, ViewChild,
} from '@angular/core';
import {DatePipe} from '@angular/common';
import {InsightsDateFilterEnums} from '../../../../enums/profile-enums';
import {UiHelperService} from "../../../../services/helpers/ui-helper.service";

@Component({
  selector: 'tl-insights-date-picker',
  templateUrl: './insights-datepicker.component.html',
  providers: [DatePipe]
})
export class InsightsDatepickerComponent implements OnInit, OnChanges {
  @Input() datepickerLabel = '';
  @Input() defaultSelectedDate: any;
  @Input() defaultSelectedFilter = InsightsDateFilterEnums.lastSevenDays;
  @Output() closeModal: EventEmitter<void> = new EventEmitter<void>();
  @Output() confirmSelectedDate: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('datepickerModal') datepickerModal: ElementRef | undefined;
  selectedDate: any;
  selectedCalendarDate: any;
  selectedFilter: any;
  maxDate = new Date();
  listOfFilters = [
    InsightsDateFilterEnums.lastSevenDays,
    InsightsDateFilterEnums.lastThirtyDays,
    InsightsDateFilterEnums.lastThreeMonths,
    InsightsDateFilterEnums.lastNineMonths,
    InsightsDateFilterEnums.lastYear,
  ];

  constructor(private datePipe: DatePipe,
              private renderer: Renderer2,
              private uiHelperService: UiHelperService) {
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.defaultSelectedDate && changes.defaultSelectedDate.currentValue) {
      this.selectedDate = changes.defaultSelectedDate.currentValue;
      this.selectedCalendarDate = this.datePipe.transform(changes.defaultSelectedDate.currentValue, 'yyyy-MM-dd');
    }

    if (changes.defaultSelectedFilter && changes.defaultSelectedFilter.currentValue) {
      this.selectedFilter = changes.defaultSelectedFilter.currentValue;
    }
  }

  onDateChange(date: any): void {
    this.selectedCalendarDate = date._d;
    this.selectedDate = date._d;
  }
}
